<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信RM唤醒设备'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="DomainName" label="唤醒锐明设备时长">
        <Select v-model="timeValue" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in timeValueOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuprmwakeupsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,


        timeValue:null,
        timeValueOptions: [
          {name: '15分钟', value: 15},
          {name: '25分钟', value: 25},
          {name: '40分钟', value: 40},
        ],
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {
        if (!this.timeValue || this.timeValue === '') {
          this.$Message.error('请选择唤醒时长')
          return
        }
        //共三条短信，对应不同密码
        // console.log(this.simNum.substring(6))

          this.sendSMS('99admin,admin,WAKEUP'+this.timeValue+'!')

          setTimeout(() => {
              this.sendSMS('99admin,JC336699,WAKEUP'+this.timeValue+'!')
            }
            ,5000)

          setTimeout(() => {
              this.sendSMS('99admin,,WAKEUP'+this.timeValue+'!')
            }
            ,10000)

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
